import { getAPIprefix } from 'api/ApiUtils';
import { v4 as uuidv4 } from 'uuid';

var IdentityServiceAPIPrefix = "https://api.identity.appmachine.in";
//var IdentityServiceAPIPrefix = "http://localhost:8082/identity-core-service";


export const sendOTPAPI = ( userId, appId, successCallBack, failuerCallback) => {

    const payload = {
        "userid":userId,
        "appid":appId
    }
    callAPI(IdentityServiceAPIPrefix+"/identity/sendotp", "POST", payload, successCallBack, failuerCallback);
    
}
export const sendCustomerOTPAPI = ( userId,successCallBack, failuerCallback) => {
    const token = localStorage.getItem("JWT");
    const payload = {
        "mobileNumber":userId,
        "appId":26,
        "businessId":8
    }
    callAPI(IdentityServiceAPIPrefix+"/identity/sendapploginotp", "POST", payload, successCallBack, failuerCallback, token);
    
}

export const AuthenticateAPI = ( otpreqid, authcode, successCallBack, failuerCallback) => {

    const payload = {
        "otpreqid":otpreqid,
        "otp":authcode
    }
    callAPI(IdentityServiceAPIPrefix+"/identity/validateotp", "POST", payload, successCallBack, failuerCallback);
    
}
export const validateCustomerOtpAPI = ( otpreqid, authcode, successCallBack, failuerCallback) => {
    const token = localStorage.getItem("JWT");
    const payload = {
        "otpreqid":otpreqid,
        "otp":authcode
    }
    callAPI(IdentityServiceAPIPrefix+"/identity/validateloginotp", "POST", payload, successCallBack, failuerCallback,token);
    
}

export const updateNameAPI = (name, otptoken, successCallBack, failuerCallback) => {

    const payload = {
        "name":name,
        "otptoken":otptoken
    }
    callAPI(IdentityServiceAPIPrefix+"/updatename", "POST", payload, successCallBack, failuerCallback);
}

export const getAuthInfoAPI = (otptoken, successCallBack, failuerCallback) => {

    const payload = {
        "otptoken":otptoken
    }
    callAPI(IdentityServiceAPIPrefix+"/getauthdetails", "POST", payload, successCallBack, failuerCallback);
}
export const callAPI = (api, method, payload, successCallBack, failuerCallBack, token) => {

    let requestOptions = {
    }

    if (method==='GET'){
        requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json' }
        }
    } else {

    
    requestOptions = {
        method: method,
        headers: token===undefined?{ 'Content-Type': 'application/json' }:{ 'Content-Type': 'application/json','Authorization': `Bearer ${token}` },
        body: JSON.stringify(payload)
    };
}
    try{
        fetch(api, requestOptions)
            .then(async (response) => {
                if (response.status === 200) {
                    const json = await response.json();
                    if (json.success === undefined){
                        successCallBack(json);
                    } else if (!json.success){
                        failuerCallBack(json);
                    } else {
                        successCallBack(json);
                    }
                    return;
                }

                let errorMessage = 'Something Went Wrong';

                if (response.status === 208) {
                    errorMessage = 'Record already exist';
                } else if (response.status === 500) {
                    errorMessage = 'Internal Server Error';
                } else {
                    try {
                        const errorJson = await response.json();
                        errorMessage = errorJson?.message || errorJson?.error || errorMessage;
                    } catch (parseError) {
                    }
                }

                failuerCallBack(errorMessage);
            })
            .catch((error) => {
                console.log(error);
                failuerCallBack(error?.message || 'Something Went Wrong');
            });
    } catch (error) {
        console.log(error);
        failuerCallBack(error?.message || 'Something Went Wrong');
    }
} 
